export const ItemTypes = {
  NOTE: 'note',
  CHANNEL: 'channel',
  FILTER: 'filter',
}
